import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/index.css";
import { AuthProvider } from "@/lib/auth";
import AppLayout from "@/components/AppLayout";
import { Toaster } from "@/components/ui/toaster";
import EnvironmentBanner from "@/components/EnvironmentBanner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvitation from "@/pages/AcceptInvitation";
import GoogleCallback from "@/pages/GoogleCallback";
import CustomerModeHandoff from "@/pages/CustomerModeHandoff";
import Donor from "@/pages/Donor";
import Overview from "@/pages/Overview";
import Expenses from "@/pages/Expenses";
import NewExpense from "@/pages/NewExpense";
import Approvals from "@/pages/Approvals";
import Reimbursements from "@/pages/Reimbursements";
import Programs from "@/pages/Programs";
import Board from "@/pages/Board";
import Members from "@/pages/Members";
import Billing from "@/pages/Billing";
import Streams from "@/pages/Streams";
import Settings from "@/pages/Settings";
import Security from "@/pages/Security";
import ExpenseDetail from "@/pages/ExpenseDetail";
import MissionControl from "@/pages/MissionControl";
import Donations from "@/pages/Donations";
import Campaigns from "@/pages/Campaigns";
import Donors from "@/pages/Donors";
import Volunteers from "@/pages/Volunteers";
import VolunteerDetail from "@/pages/VolunteerDetail";
import DonorPortal from "@/pages/DonorPortal";
import PublicTrustPage from "@/pages/PublicTrustPage";
import Reports from "@/pages/Reports";
import AuditLogs from "@/pages/AuditLogs";
import { BillingSuccess, BillingCancel } from "@/pages/BillingResult";

// Core Spec Implementation Pages
import ContactsPage from "@/pages/ContactsPage";
import VolunteerSignupPage from "@/pages/VolunteerSignupPage";
import ExpenseSubmissionPage from "@/pages/ExpenseSubmissionPage";
import ExpenseApprovalsPage from "@/pages/ExpenseApprovalsPage";
import AidIntakePage from "@/pages/AidIntakePage";
import WorkflowBuilderPage from "@/pages/WorkflowBuilderPage";
import CommunicationsPage from "@/pages/CommunicationsPage";
import ExecutiveDashboard from "@/pages/ExecutiveDashboard";
import BeneficiaryPortal from "@/pages/BeneficiaryPortal";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/accept-invitation" element={<AcceptInvitation />} />
          <Route path="/auth/google/callback" element={<GoogleCallback />} />
          <Route path="/customer-mode/handoff" element={<CustomerModeHandoff />} />
          <Route path="/donor-portal" element={<DonorPortal />} />
          <Route path="/portal/aid" element={<BeneficiaryPortal />} />
          <Route path="/mission-control" element={<MissionControl />} />
          <Route path="/donor/:slug" element={<Donor />} />
          <Route path="/public/volunteer-signup" element={<VolunteerSignupPage />} />
          <Route path="/public/aid-intake" element={<AidIntakePage />} />

          {/* Billing result pages */}
          <Route path="/app/billing/success" element={<BillingSuccess />} />
          <Route path="/app/billing/cancel" element={<BillingCancel />} />

          {/* Authenticated app */}
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<Overview />} />
            <Route path="contacts" element={<ContactsPage />} />
            <Route path="volunteer-signup" element={<VolunteerSignupPage />} />
            <Route path="expense-submission" element={<ExpenseSubmissionPage />} />
            <Route path="expense-approvals" element={<ExpenseApprovalsPage />} />
            <Route path="aid-intake" element={<AidIntakePage />} />
            <Route path="workflows" element={<WorkflowBuilderPage />} />
            <Route path="communications" element={<CommunicationsPage />} />
            <Route path="executive-dashboard" element={<ExecutiveDashboard />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="expenses/new" element={<NewExpense />} />
            <Route path="expenses/:id" element={<ExpenseDetail />} />
            <Route path="approvals" element={<Approvals />} />
            <Route path="reimbursements" element={<Reimbursements />} />
            <Route path="programs" element={<Programs />} />
            <Route path="streams" element={<Streams />} />
            <Route path="board" element={<Board />} />
            <Route path="members" element={<Members />} />
            <Route path="billing" element={<Billing />} />
            <Route path="settings" element={<Settings />} />
            <Route path="security" element={<Security />} />
            <Route path="donations" element={<Donations />} />
            <Route path="campaigns" element={<Campaigns />} />
            <Route path="donors" element={<Donors />} />
            <Route path="volunteers" element={<Volunteers />} />
            <Route path="volunteers/:id" element={<VolunteerDetail />} />
            <Route path="reports" element={<Reports />} />
            <Route path="trust-page" element={<PublicTrustPage />} />
            <Route path="audit-log" element={<AuditLogs />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
      <EnvironmentBanner />
    </AuthProvider>
  );
}

export default App;
